import React, { useRef, useState, useEffect } from "react";
import styles from "./MissionAndVision.module.scss";
import WhyChooesAptechAboutUs from "../../../assets/images/WhyChooesAptechAboutUs.png";
import ImageTextSection from "../../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../../CommonComponents/BreadCrumb.tsx";
import { Icon } from "../../../assets/Icons.tsx";
import missionAndVisionBanner2 from "../../../assets/images/missionAndVisionBanner2New.png";
import { motion } from "framer-motion";
import MetaComponent from "../../CommonComponents/MetaComponent.tsx";

const items: string[] = [
  "Through our unwavering commitment to the society, Aptech continues to make significant contributions to global education and skill development, shaping the future of learners by effectively preparing them for vocational jobs in demand worldwide.",
];
interface DataItem {
  src: string;
  title: string;
  description: string;
}
const data: DataItem[] = [
  {
    src: "mission",
    title: "Mission",
    description:
      "To be a trusted, self-reliant and widely recognized Indian brand, with global footprint delivering vocational training, skilling, and non-formal education to students, professionals, universities, and corporates, aiming to create and foster an ecosystem where youth are skilled, trained, and prepared for successful employment or entrepreneurship.",
  },
  {
    src: "vision",
    title: "vision",
    description:
      "To be the preferred learning solutions company offering vocational training, skilling and non-formal education, and make our students highly employable and job-ready with our industry relevant course curriculum.",
  },
];

const MissionVision: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "About Us", link: "/about-us" },
    { title: "Mission and Vision", link: "" },
  ];
  const sections = [
    { component: <Banner />, ref: useRef(null) },
    { component: <MissionVisionSection />, ref: useRef(null) },
    { component: <WhyAptechListView />, ref: useRef(null) },
  ];

  const [visibleSections, setVisibleSections] = useState<
    Record<number, boolean>
  >({});
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [parseInt(entry.target.dataset.section || "0")]: true,
            }));
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach(({ ref }, index) => {
      if (ref.current) {
        ref.current.dataset.section = index.toString();
        observer.observe(ref.current);
      }
    });

    return () => {
      sections.forEach(({ ref }) => {
        if (ref.current) observer.unobserve(ref.current);
      });
      observer.disconnect();
    };
  }, []);

  return (
    <div id="WhyAptechPage" className={`${styles.whyAptechPage}`}>
      <MetaComponent
        title="Non Formal Education | Aptech’s Mission & Vision For Short Term Training Programs"
        desc="Discover Aptech’s mission and vision behind its non-formal education model, delivering short-term skill-based training programs that promote employability and growth."
      />
      <BreadCrumb menu={breadcrumb} />
      {sections.map(({ component, ref }, index) => (
        <motion.div
          key={index}
          ref={ref}
          initial={{ opacity: 0, y: 100 }}
          animate={visibleSections[index] ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          {component}
        </motion.div>
      ))}
    </div>
  );
};

const Banner = () => {
  const content = [
    `<a href="/">Aptech</a> aims is to create an ecosystem that helps young people gain skills, training, and employment. Aptech's vision is to bridge the skills gap and enhance employability.`,
    `By providing industry-aligned training and development programs, Aptech offers career growth opportunities that empower students and professionals to succeed in their chosen fields.`,
  ];
  return (
    <div className="container">
      <div className="section">
        <div className="row mt-5">
          <div className="col-12">
            <ImageTextSection
              imageSrc={"/images/teamwork-digital-collaboration.png"}
              imageAlt="Team Collaboration With Digital Technology Interface"
              imageTitle="Team Collaboration With Digital Technology Interface"
              content={content}
              heading=""
              reverse={true}
              imageAlign="center"
              imageAlignInMob="center"
              imageHeightTablet="25rem"
              imageHeight="22rem"
              contentPosition={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const WhyAptechListView = () => {
  return (
    <div className="container-fluid">
      <div className="">
        <div className={`row ${styles.listBox} g-0`}>
          <div className="col-12">
            <div className="container">
              <div className="row g-0">
                <div
                  className={`col-lg-8  col-md-12 col-sm-12 col-xl-9 d-flex justify-content-center align-items-center`}
                >
                  {items.map((item, index) => (
                    <p key={index} className={`para ${styles.listDiv}`}>
                      <strong>{item}</strong>
                    </p>
                  ))}
                </div>

                <div
                  className={`col-lg-4 col-md-12 col-sm-12 col-xl-3 align-items-stretch ${styles.imgDiv}`}
                >
                  <img
                    src={missionAndVisionBanner2}
                    alt="AptechImage"
                    className={`img-fluid ${styles.AbousWhychooseAptechBanner2}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const MissionVisionSection = () => {
  return (
    <div className="container">
      <div className="section">
        <div className={`row g-2`}>
          {data.map((item, index) => (
            <div
              key={index}
              className=" col-md-12 col-lg-6 col-sm-12 mb-4 d-flex"
            >
              <div className={styles.missionVisionSection}>
                <div className="row mb-2">
                  <div className="col-12">
                    <Icon name={item.src} />
                    <h6 className="heading mb-0">{item.title}</h6>
                    <p className="para pt-3">{item.description}</p>
                  </div>
                  {/* <div className="col-6 d-flex justify-content-end align-items-end">
                    <Icon name={item.src} width="150px" height="150px" />
                  </div> */}
                </div>
                {/* <div className="row">
                  <p className="para pt-3">{item.description}</p>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MissionVision;
